import React, {Component} from "react";
import {withStyles, Box, Grid, Button, Select, MenuItem, TextField, FormControl, FormHelperText} from "@material-ui/core";
import {inject, observer} from "mobx-react";
import clsx from "clsx";
import _ from "lodash";

import {styles} from "./styles";
import {addUserFields, viewList} from "../../constants/settings";
import UsersList from "./usersList";
import {ModalDialog} from "../../components/Modal";
import { validateField } from "../../validations/Rules";
import UserGroups from "./userGroups";
import Password from "../../components/Password";

@inject('usersManager')
@observer
class UsersManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 'users',
      openModal: false,
      submitting: false,
      user: {},
      validates: {
        nickname: ['required'],
        email: ['required', 'email'],
        scope: ['required'],
        phone: ['required', 'phone_number'],
        username: ['required'],
        password: ['required', 'password'],
      },
      formErrors: {},
      errors: [],
    }
  }

  openEditUser = (user) => {
    const currentUser = {
      ...user,
      nickname: user.info.nickname,
      scope: user._scopes && user._scopes.includes("client-admin") ? "client-admin" : user._scopes
    };
    delete currentUser._scopes;
    delete currentUser.info;

    this.setState({
      openModal: true,
      user: currentUser
    });
  }

  onSubmit = () => {
    const { user, formErrors, validates } = this.state;
    const { password: _password, ...restValidates } = validates;
    const { usersManager } = this.props;
    const isEditting = Boolean(user.id);
    const { password, ...userWithoutPassword } = user;

    if (!_.isEmpty(formErrors)) return;

    Object.keys(isEditting ? validates : restValidates).map((f) => this.handleValidate(f, user[f]));
    if (!_.isEmpty(formErrors)) return;

    this.setState({submitting: true});
    if (isEditting) {
      usersManager.editUser({ ...userWithoutPassword, auth_password: user.password}, this.onSubmitDone);
    } else {
      usersManager.addUser(userWithoutPassword, this.onSubmitDone);
    }
  }

  onSubmitDone = (res) => {
    const {usersManager} = this.props;

    this.setState({submitting: false});
    if (!res) return;
    if (!res.ok) {
      this.setState({errors: res.data && res.data.errors ? res.data.errors : [res.data.message]});
    } else {
      usersManager.search();
      this.closeModal();
    }
  }

  closeModal = () => {
    this.setState({
      openModal: false,
      user: {},
      formErrors: {},
      errors: [],
    });
  }

  onChangeInput = (field, value) => {
    const {user} = this.state;
    const updated = {[field]: value};
    if (field === 'email' && !user?.id) {
      updated['username'] = value;
    }
    const limited = addUserFields.filter(f => f.name === field && !!f.length).shift();
    if (limited && limited.length) {
      if (value.length > limited.length) {
        value = value.substr(0, limited.length);
      }
      updated[field] = value;
    }
    this.setState({
      user: {...user, ...updated},
      errors: [],
    });
    this.handleValidate(field, value);
  }

  validateRule = (rule, name, value) => {
    return validateField(rule, name, value);
  };

  handleValidate = (name, value) => {
    if (this.state.validates[name]) {
      const errors = [];
      for (const rule of this.state.validates[name]) {
        const error = this.validateRule(rule, name, value);
        if (error) {
          errors.push(error)
          // set error data
          const currentErrors = this.state.formErrors;
          const newErrors = _.merge(currentErrors, {[name]: errors.join(', ')});

          this.setState({ formErrors: newErrors });
          break;
        }
      }

      if (!errors.length) {
        // if not error reset error for this field
        const currentErrors = this.state.formErrors;
        delete currentErrors[name];

        this.setState({formErrors: currentErrors});
      }
    }
  };

  render() {
    const {view, user, openModal, errors, formErrors, submitting} = this.state;
    const { classes } = this.props;
    const isEditting = Boolean(user.id);

    return (
      <Box className={clsx({[classes.wrapper]: true, [classes.container]: true})}>
        <Box align="left" component="h3" className={classes.headerTitle}>Organization Directory</Box>
        <Box>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <span>View by</span>
              <Select
                className={classes.viewListSelection}
                value={view}
                onChange={e => this.setState({view: e.target.value})}
              >
                {viewList.map(opt => (
                  <MenuItem value={opt.value} key={opt.value}>{opt.label}</MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item>
              {view === 'users' && (
                <Button onClick={() => this.setState({openModal: true})} variant="outlined" color="primary" className={classes.addUserBtn}>
                  Add user +
                </Button>
              )}
            </Grid>
          </Grid>
          <Box p={1} mt={2}>
            {view === 'users' && <UsersList openEditUser={this.openEditUser} />}
            {view === 'roles' && <UserGroups />}
          </Box>

          <ModalDialog
            error={errors}
            open={openModal}
            onClose={this.closeModal}
            onOk={this.onSubmit}
            title={isEditting ? "Edit User" : "Add User"}
            okLabel={isEditting ? "Save" : "Add"}
            loading={submitting}
            disabledOk={!_.isEmpty(formErrors) || !user.email}
          >
            {isEditting && (
              <Box>
                <span className={classes.inputLabel}>User ID:</span>
                <span className={classes.userId}>{user.id}</span>
              </Box>
            )}
            {addUserFields.map(field => (
              <Box my={2} key={field.name}>
                <Box className={classes.inputLabel}>{field.label} *</Box>
                {!field.options ? (
                  <TextField
                    error={!!formErrors[field.name]}
                    helperText={formErrors[field.name]}
                    value={user[field.name] || ''}
                    onChange={e => this.onChangeInput(field.name, e.target.value)}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    disabled={field.disabled}
                    className={classes.input}
                  />
                ) : (
                  <FormControl fullWidth>
                    <Select
                      error={!!formErrors[field.name]}
                      value={user[field.name] || ''}
                      onChange={e => this.onChangeInput(field.name, e.target.value)}
                      variant="outlined"
                      margin="dense"
                    >
                      {field.options.map(opt => (
                        <MenuItem value={opt.value} key={opt.value}>{opt.label}</MenuItem>
                      ))}
                    </Select>
                    {!!formErrors[field.name] && (
                      <FormHelperText error margin="dense" variant="outlined">{formErrors[field.name]}</FormHelperText>
                    )}
                  </FormControl>
                )}
              </Box>
            ))}
            {!isEditting && (
              <Box py={1} className={classes.hint}>*Password is going to be auto-generated and sent to user’s registered email</Box>
            )}

            {isEditting && (
              <Password
                value={user.password}
                onChange={(e) => this.onChangeInput('password', e.target.value)}
                label="YOUR PASSWORD"
                placeholder=""
                required={true}
                showLabel={true}
                classes={{ inputLabel: classes.inputLabel }}
                error={!!formErrors?.password}
                helperText={formErrors?.password}
              />
            )}
          </ModalDialog>
        </Box>
      </Box>
    );
  }
}

export default withStyles(styles)(UsersManager);